import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Card from "../../Components/Cards/Card";
import axios from "axios";
import swal from 'sweetalert';
import "../../assets/css/pages/notifications.css";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";
import {generateUrl} from "../../Components/Helpers/Utils";

const AdminProfile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const params = useParams();
    const [notification, setNotification] = useState([]);
    const [createdDate, setCreatedDate] = useState();
    const [isActive, setIsActive] = useState(null);
    const [detailsUrl, setDetailsUrl] = useState(null);

    useEffect(() => {
        axios.get('/notifications/' + params.id)
            .then(response => {
                let tempData = response?.data?.notification;
                setNotification(tempData);
                setIsActive(tempData?.is_active);
                let createdAt = new Date(tempData?.created_at).toLocaleDateString('en-GB');
                setCreatedDate(createdAt);
                setDetailsUrl(generateUrl(tempData?.url_params))
                if (response.status == 200 && tempData.is_read == false) {
                    axios.post('/mark-notifications-read/' + params.id);
                    dispatch({ type: 'DECREMENT_NOTIFICATION' });
                }
            })
    }, [location])

    const deleteNotification = (id, name) => {
        swal({
            title: "Are you sure?",
            text: 'You want to delete notification "' + name + '"?',
            icon: "warning",
            buttons: true,
            dangerMode: true,
            confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        }).then((result) => {
            if (result == true) {
                axios.delete('notifications/' + params.id)
                    .then(function (res) {
                        console.log(res);
                        if (res.status == 200) {
                            swal('The notification "' + name + '" has been deleted!', {
                                icon: "success",
                            });
                            navigate("/notifications");
                            return true;
                        } else {
                            return false;
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
            }
        });
    }

    return (
        <>
            <Card title="See Notification" classes="notification" bodyClasses="pt-10">
                <div className="row">
                    <div className="col-12 mb-5">
                        <button
                            className="btn btn-primary"
                            onClick={() => { navigate("/notifications"); }}
                        >
                            Notifications list
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger mt-3 mr-3 float-right"
                            onClick={
                                () => { deleteNotification(notification.id, notification.title); }
                            }
                        >
                            <i className="far fa-trash-alt fs-6 mr-3"></i>
                            Delete
                        </button>
                    </div>
                    <div className="col-md-12 ls-1 font-weight-normal">
                        <ul className="li-style-none px-0">
                            <li>
                                <h5 className="d-block mb-5">
                                    <div className="fw-bolder mb-2 mt-3 border-bottom pb-8">Message: </div>
                                    <div className="message">
                                        {
                                            detailsUrl ?
                                              <a href={`/${detailsUrl}`}>
                                                  {notification.message ? notification.message : "N/A"}
                                              </a>
                                              : notification.message ? notification.message : "N/A"
                                        }
                                    </div>
                                </h5>
                            </li>
                        </ul>
                    </div>
                </div>
            </Card>
        </>
    )
}

export default AdminProfile;